import React from 'react'
import { connect} from 'react-redux'
import { withRouter, Link } from 'react-router-dom'
import AddFoodItem from './AddFoodItem'
// import MyRequestsBusiness from './MyRequestsBusiness'

const BusinessDashboard = (props) => {
    
    const {loggedUser} = props
    console.log(loggedUser)
    return (
        <div>
            <h1>Dashboard</h1>
            <p>Current User: {loggedUser.username}</p>
            <p>Current Address: {loggedUser.address}</p>
            <p>Current Contact #: {loggedUser.phone}</p>
            <p>Current Contact Email: {loggedUser.email}</p>
            <a href="#neworder" className="abutton" role="button">Create a new Order</a>
            <div className="modal" id="neworder">
                <div className="modal-container">
                    <AddFoodItem />
                    <a href="#" className="abutton2" role="button">Close</a>
                </div>
            </div>
            <br />
            <Link to='/UpdateFoodItem' style={{ textDecoration: 'none' }}><span className="abutton">Update/Delete a Food Item</span></Link>
            <br /><br />
            {/* <button type="button" className="abutton">Log Out</button> */}
            <Link to='/' style={{ textDecoration: 'none' }}><span className="abutton">Log Out</span></Link>            
            {/* <MyRequestsBusiness /> */}
        </div>
    )
}

const mapStateToProps = (state) => {
    return {loggedUser: state.loggedUser}
}



export default withRouter(
    connect(
        mapStateToProps,
    )(BusinessDashboard)
)
